import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FadeUp, MaskedLines, Eyebrow } from "@/components/Reveal";
import { PhoneFrame, MyDateScreen } from "@/components/PhoneMockup";

const MINI_STEPS = [
  "İlgilendiğin kişiye My Date isteği gönder",
  "İlgi karşılıklı olduğunda eşleşme başlar",
  "Özel eşleşme alanınız açılır",
];

export default function MyDate({ showLink = true }) {
  return (
    <section data-testid="my-date-section" className="relative py-24 sm:py-36 overflow-hidden bg-ivory-rose">
      <div aria-hidden="true" className="absolute top-0 left-1/3 w-[460px] h-[460px] rounded-full bg-rose-light/70 blur-3xl" />

      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-16 items-center relative">
        <div className="relative flex justify-center order-2 lg:order-1">
          <div aria-hidden="true" className="absolute w-[340px] h-[340px] rounded-full bg-rose/25 blur-2xl top-1/2 -translate-y-1/2" />
          <FadeUp delay={0.15} className="relative">
            <PhoneFrame>
              <MyDateScreen />
            </PhoneFrame>
          </FadeUp>
        </div>

        <div className="order-1 lg:order-2">
          <FadeUp>
            <Eyebrow>My Date</Eyebrow>
          </FadeUp>
          <h2 className="mt-7 font-serif text-3xl sm:text-4xl lg:text-5xl leading-[1.12] tracking-tight text-ink">
            <MaskedLines
              lines={[
                "Karşılıklıysa,",
                <em key="em" className="italic text-burgundy">
                  It&rsquo;s a Date.
                </em>,
              ]}
            />
          </h2>
          <FadeUp delay={0.2} className="mt-6 max-w-md text-base font-light text-ink-soft/90 leading-relaxed">
            İlgilendiğin kişiye My Date isteği gönder. İlgi karşılıklı olduğunda özel eşleşme alanınız açılır.
          </FadeUp>

          <div className="mt-10 space-y-0 max-w-md">
            {MINI_STEPS.map((s, i) => (
              <FadeUp key={i} delay={0.25 + i * 0.1}>
                <div className="flex items-baseline gap-5 border-t border-burgundy/10 py-5">
                  <span className="font-cinzel text-sm text-gold">{String(i + 1).padStart(2, "0")}</span>
                  <p className="text-[15px] font-light text-ink-soft leading-relaxed">{s}</p>
                </div>
              </FadeUp>
            ))}
            <div className="border-t border-burgundy/10" />
          </div>

          {showLink && (
            <FadeUp delay={0.55} className="mt-9">
              <Link to="/my-date" data-testid="my-date-more-link" className="link-ghost">
                My Date&rsquo;i keşfet
                <ArrowRight className="w-4 h-4" aria-hidden="true" />
              </Link>
            </FadeUp>
          )}
        </div>
      </div>
    </section>
  );
}
